// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"291d12c9","994":"8293ad38"}[chunkId] + ".chunk.css";
};